module.exports = __webpack_public_path__ + "assets/images/default-story.dbc07784ec652dc429c80c64e492a710.svg";